import { render, staticRenderFns } from "./DraftSplashScreen.vue?vue&type=template&id=05753178"
import script from "./DraftSplashScreen.vue?vue&type=script&lang=js"
export * from "./DraftSplashScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports